<template>
  <v-app class="home-app">
    <SiteHeader :auth="auth" @login="openLogin()" />
    <main class="home-app__main">
      <slot />
    </main>
    <SiteFooter />
    <CookieConsent simple />
    <v-dialog v-model="loginDialog" content-class="loginDialog" overlay-color="#322132" overlay-opacity="0.6">
      <LoginRegister @toggleDialog="toggleDialog()" @closeLoginDialog="loginDialog = false" :redirectHome="false" :baseurl="baseurl"></LoginRegister>
    </v-dialog>
  </v-app>
</template>

<script>
import LoginRegister from '@/Shared/LoginRegister'
import SiteHeader from '@/Shared/SiteHeader'
import SiteFooter from '@/Shared/SiteFooter'
import CookieConsent from '@/Shared/CookieConsent'

// Layout for the redesigned home page. Other pages still use VuetifyLayout;
// the login dialog, login prompt and ltoken cookie behave the same as there.
export default {
  components: {
    LoginRegister,
    SiteHeader,
    SiteFooter,
    CookieConsent,
  },
  props: {
    auth: Object,
    state: String,
    baseurl: String,
  },
  provide() {
    return {
      openLogin: this.openLogin,
    }
  },
  data() {
    return {
      loginDialog: false,
      action: null,
    }
  },
  mounted() {
    if (!this.auth || !this.auth.user) {
      this.setCookie('ltoken', 0, -1, '', '/')
      setTimeout(() => {
        if (!this.loginDialog && (!this.auth || !this.auth.user))
          this.toggleDialog()
      }, 1000 * 60)
    } else {
      this.setCookie('ltoken', 1, 365, '', '/')
    }
  },
  methods: {
    openLogin(action = null) {
      this.loginDialog = true
      this.action = action
    },
    toggleDialog() {
      this.loginDialog = !this.loginDialog
      this.action = null
    },
    setCookie(name, value, expiryDays, domain, path) {
      const exdate = new Date()
      exdate.setDate(exdate.getDate() + (expiryDays || 365))
      const cookie = [
        `${name}=${value}`,
        `expires=${exdate.toUTCString()}`,
        `path=${(path || '/')}`,
      ]
      if (domain) {
        cookie.push(`domain=${domain}`)
      }
      document.cookie = cookie.join(';')
    },
  },
}
</script>

<style scoped>
.home-app {
  background: #FFFFFF;
}
.home-app__main {
  flex: 1 0 auto;
}
</style>
